import moment from 'moment'

import BaseInputDate from 'app/components/forms/base_inputDate/component'
import {
  firstElementOrEmptyString,
  withValidation,
} from 'app/components/forms/util'
import * as validations from 'app/shared_components/validations'
import * as helpers from 'app/sm/helpers'
import * as viewingsHelpers from 'app/utils/viewings/helpers'

const futureDateValidatorOneDayLater = (date) => {
  return validations.compareDatesOneDayLater(
    moment().format(helpers.dateWithDash),
    date,
    'This field is required',
    viewingsHelpers.oneDayLaterErrorMessage,
  )
}

const validateFutureDateFlattened = (date) =>
  firstElementOrEmptyString(futureDateValidatorOneDayLater(date))

const InputFutureDateOneDayLater = withValidation(
  BaseInputDate,
  validateFutureDateFlattened,
)

export default InputFutureDateOneDayLater
